import { useState } from 'react'
import { ItemDetailCard } from '../../projectData'

const isVoucherLink = (code) => {
    if (!code || typeof code !== 'string') return false
    return /^https?:\/\//i.test(code.trim())
}

const getVoucherUrls = (voucherCode) => {
    if (!voucherCode) return []
    // Handles cases where multiple URLs (with or without http(s)) are separated by & but string may contain more than just that char.
    return voucherCode
        .split('&')
        .map(url => url.trim())
        .filter(url =>
            url.length > 0 &&
            (url.startsWith('http://') || url.startsWith('https://') || /^www\./i.test(url))
        );
}
/**
 * VoucherDetail component
 * Displays details of a voucher redemption, including voucher code, pin, validity, download date, and usage instructions.
 */
export const VoucherDetail = ({ data }) => {
    const [showVoucherPopup, setShowVoucherPopup] = useState(false)
    const [selectedUrl, setSelectedUrl] = useState(null)
    const voucherCode = data?.voucher_code
    const isLink = isVoucherLink(voucherCode)
    const urls = getVoucherUrls(voucherCode)
    const overlayStyles = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1040,
    }

    const modalStyles = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95%',
        maxWidth: '900px',
        height: '85vh',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        zIndex: 1050,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    }

    return (
        <div className='mt-4'>
            <div className='col-sm-12 mt-4'>
                <div className="card  p-2" style={{ border: '1px solid #eaeaea', backgroundColor: "#EFEFEF" }}>
                    <div className="d-flex justify-content-between  p-2 ">
                        <div className="fw-semibold fs-6">Redemption Id: <span className='fw-semibold'>{data?.order_id}</span></div>
                        <div className="fw-semibold fs-6">Date:<span className='fw-semibold'> {data?.order_date}</span> </div>
                    </div>
                    <>
                        <ItemDetailCard data={data} />
                    </>
                </div>
            </div>
            {Number(data?.voucher_download_status) === 1 &&
                <div style={{ border: '1px solid #eaeaea' }} className='card mt-4'>
                    {isLink ? (
                        <>
                            {urls.map((url, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className="btn btn-sm btn-danger fs-3 fw-semibold mt-1"
                                    onClick={() => { console.log(url); setSelectedUrl(url); setShowVoucherPopup(true) }}
                                >
                                    View your voucher code
                                </button>
                            ))}
                        </>
                    ) : (
                        <>
                            <div className="card-header px-6 py-3" style={{ minHeight: '39px', backgroundColor: '#CB171A' }}>
                                <div className="d-flex justify-content-between  w-100">
                                    <div className="text-white  fw-semibold">
                                        <div>Voucher Code</div>
                                        <div>

                                            {voucherCode}

                                        </div>
                                    </div>
                                    <div className="text-white text-end fw-semibold">
                                        <div> Voucher Pin </div>
                                        <div> {data?.voucher_pin} </div>
                                    </div>
                                </div>

                            </div>
                            <div className="card-body p-4 border-top">
                                <div className='d-flex justify-content-between'>
                                    <div className='fs-6 fw-semibolder'>Valid From</div>
                                    <div className='fs-6 fw-semibolder'>Valid Till</div>
                                </div>
                                <div className='col-12 pb-4'>
                                    <div className='d-flex justify-content-between'>
                                        <div className=' '>{data?.voucher_start ? data?.voucher_start : '---'}</div>
                                        <div className=''>{data?.voucher_expiry ? data?.voucher_expiry : '---'}</div>
                                    </div>
                                </div>
                                <div sty className='card  p-4 fw-semibold fs-6 ' style={{ backgroundColor: "#FFE6E7" }}>
                                    <div className='d-flex justify-content-center'>Date of Download - {data?.voucher_viewed_at ? data?.voucher_viewed_at : '---'}</div>
                                </div>
                                {/* <div className='p-4 fs-5 fw-semibolder text-center'>
                        Amount :- Rs 342894/-
                    </div> */}
                            </div>
                        </>
                    )}
                </div>
            }
            <div style={{ border: '1px solid #eaeaea' }} className="card mt-4">
                <div className="card-header bg-dark px-6" style={{ minHeight: '39px' }}>
                    <div className="card-title fw-semibold fs-5  text-white ">How To Use This Voucher ?
                    </div>
                </div>
                <div className="card-body pt-4 px-6">
                    <div className="fw-semibolder fs-5 mb-2">
                        1 &nbsp; Find The Voucher Code
                    </div>
                    <div className="mb-2" style={{ color: "#848484" }}>
                        The voucher code is shared in the voucher redemption history detail page.
                    </div>
                    <div className="fw-semibolder fs-5 mb-2">
                        2 &nbsp; Apply The Voucher Code
                    </div>
                    <div className="mb-2" style={{ color: "#848484" }}>
                        At checkout, enter the code in the “Voucher Code” or “Promo Code” field.
                    </div>
                    <div className="fw-semibolder fs-5 mb-2">
                        3 &nbsp; Complete The Purchase
                    </div>
                    <div className="mb-2" style={{ color: "#848484" }}>
                        Review your order to ensure the discount has been applied.
                        Then, proceed to complete the purchase by providing payment details and any other necessary information.
                    </div>
                </div>
            </div>

            {isLink && showVoucherPopup && selectedUrl && (
                <>
                    <div style={overlayStyles} onClick={() => setShowVoucherPopup(false)} />
                    <div style={modalStyles}>
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                            <div className="fw-semibold fs-5">Your Voucher Code</div>
                            <button
                                type="button"
                                className="btn btn-sm btn-light"
                                onClick={() => setShowVoucherPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                        <iframe
                            src={selectedUrl}
                            title="Voucher Code"
                            width="100%"
                            style={{ flex: 1, border: 'none' }}
                        />
                    </div>
                </>
            )}

        </div>
    )
}
